<template>
    <div>
        <div>
            <div class="mb-3">
                <strong class="header-case">{{ __('Report Type') }}</strong>
                <div>
                    <select v-model="reportType">
                        <option value="pdf">{{ __('PDF Report') }}</option>
                        <option value="xls">{{ __('Excel Report') }}</option>
                    </select>
                </div>
            </div>
            <div class="mb-3">
                <strong class="header-case">{{ __('Period Type') }}</strong>
                <div>
                    <select v-model="periodType">
                        <option value="last_week">{{ __('Last Week') }}</option>
                        <option value="last_month">{{ __('Last Month') }}</option>
                        <option value="month_to_date">{{ __('Month To Date') }}</option>
                        <option value="year_to_date">{{ __('Year To Date') }}</option>
                    </select>
                </div>
            </div>
            <div class="mb-3">
                <strong class="header-case">{{ __('Frequency') }}</strong>
                <div>
                    <select v-model="frequency">
                        <option value="week">{{ __('Each Week') }}</option>
                        <option value="month">{{ __('Each Month') }}</option>
                        <option value="year">{{ __('Each Year') }}</option>
                    </select>
                </div>
            </div>
            <div class="mb-3 row">
                <div class="col-4">
                    <strong class="header-case">{{ __('Day Offset') }}</strong>
                    <div>
                        <select class="form-style" v-model="dayOffset">
                            <option value="0">{{ __('Monday') }}</option>
                            <option value="1">{{ __('Tuesday') }}</option>
                            <option value="2">{{ __('Wednesday') }}</option>
                            <option value="3">{{ __('Thursday') }}</option>
                            <option value="4">{{ __('Friday') }}</option>
                            <option value="5">{{ __('Saturday') }}</option>
                            <option value="6">{{ __('Sunday') }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-4">
                    <strong class="header-case">{{ __('Sending Hour') }}</strong>
                    <div>
                        <input class="form-style" type="time" v-model="sendingTime" step="3600" />
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <strong class="header-case">{{ __('Timezone') }}</strong>
                <div>
                    <select v-model="timezone">
                        <option disabled value="">Select Timezone</option>
                        
                        <!-- GMT - -->
                        <option value="Etc/GMT+12">(GMT-12:00) International Date Line West</option>
                        <option value="Pacific/Midway">(GMT-11:00) Midway Island, Samoa</option>
                        <option value="Pacific/Honolulu">(GMT-10:00) Hawaii</option>
                        <option value="America/Anchorage">(GMT-09:00) Alaska</option>
                        <option value="America/Los_Angeles">(GMT-08:00) Pacific Time (US & Canada)</option>
                        <option value="America/Denver">(GMT-07:00) Mountain Time (US & Canada)</option>
                        <option value="America/Chicago">(GMT-06:00) Central Time (US & Canada)</option>
                        <option value="America/New_York">(GMT-05:00) Eastern Time (US & Canada)</option>
                        <option value="America/Halifax">(GMT-04:00) Atlantic Time (Canada)</option>
                        <option value="America/Argentina/Buenos_Aires">(GMT-03:00) Buenos Aires, Georgetown</option>
                        <option value="America/Noronha">(GMT-02:00) Mid-Atlantic</option>
                        <option value="Atlantic/Cape_Verde">(GMT-01:00) Cape Verde Islands</option>
                        
                        <!-- GMT + -->
                        <option value="Etc/GMT">(GMT+00:00) Greenwich Mean Time (Zulu - Z)</option>
                        <option value="CET">(GMT+01:00) Central European Time (Alpha - A)</option>
                        <option value="EET">(GMT+02:00) Eastern European Time (Bravo - B)</option>
                        <option value="Europe/Moscow">(GMT+03:00) Moscow Time (Charlie - C)</option>
                        <option value="Asia/Yerevan">(GMT+04:00) Armenia Time (Delta - D)</option>
                        <option value="Asia/Karachi">(GMT+05:00) Pakistan Standard Time (Echo - E)</option>
                        <option value="Asia/Omsk">(GMT+06:00) Omsk Time (Foxtrot - F)</option>
                        <option value="Asia/Krasnoyarsk">(GMT+07:00) Krasnoyarsk Time (Golf - G)</option>
                        <option value="Asia/Shanghai">(GMT+08:00) China Standard Time (Hotel - H)</option>
                        <option value="Asia/Tokyo">(GMT+09:00) Japan Standard Time (India - I)</option>
                        <option value="Australia/Sydney">(GMT+10:00) Eastern Australia Standard Time (Kilo - K)</option>
                        <option value="Asia/Sakhalin">(GMT+11:00) Sakhalin Time (Lima - L)</option>
                        <option value="Pacific/Auckland">(GMT+12:00) New Zealand Standard Time (Mike - M)</option>
                        <option value="Pacific/Tongatapu">(GMT+13:00) Nuku'alofa</option>
                        <option value="Pacific/Kiritimati">(GMT+14:00) Line Islands</option>
                    </select>
                </div>
            </div>
            <div class="mb-3">
                <strong class="header-case">{{ __('Emails') }}</strong>
                <multi-text-input v-model="emails" ref="email-input" />
            </div>
        </div>
        <button
            @click="sendScheduleRequest"
            class="btn btn-primary mb-3"
            :disabled="saving"
        >
            {{ saving ? "Saving..." : "Add to Schedule" }}
        </button>
    </div>
</template>

<script>
import MultiTextInput from "../generic/MultiTextInput.vue";
export default {
    components: {
        MultiTextInput
    },
    computed: {
        sendingHour() {
            return this.sendingTime.split(":")[0];
        },
    },
    data() {
        return {
            periodType: "last_month",
            frequency: "week",
            dayOffset: 0,
            sendingTime: "07:00",
            reportType: 'pdf',
            timezone: "",
            emails: [],
            saving: false
        }
    },
    methods: {
        reset() {
            this.periodType = "last_month";
            this.frequency = "week";
            this.dayOffset = 0;
            this.sendingTime = "07:00";
            this.reportType = 'pdf',
            this.timezone = "";
            this.emails = [];
            this.$refs?.["email-input"].clearElements();
        },
        async sendScheduleRequest() {
            let link = "/api/report/schedule/reviews/" + Spark.state.currentTeam.id;

            let body = {
                period_type: this.periodType,
                day_offset: this.dayOffset,
                sending_hour: this.sendingHour,
                report_type: this.reportType,
                timezone: this.timezone,
                emails: this.emails,
                frequency: this.frequency
            };

            this.saving = true;
            try {
                let response = await axios.post(link, body);
                this.showSuccessMessage();
                this.reset();
            } catch (error) {
                console.error(error);
            }
            this.saving = false;
        },
        showSuccessMessage() {
            swal(
                "Done!",
                "The report has been successfully scheduled.",
                "success"
            );
        }
    }
}
</script>
